// extracted by mini-css-extract-plugin
export default {"buttons":"aFYiq","navigationButtons":"NRak-","cancelButton":"vqMc2"};